// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iE_R","clinicsSelect":"styles_clinicsSelect__fumPv"};